import {
  type CustomFieldData,
  type CustomFieldUpdateInput,
  type CustomFieldUpdateSuccess,
  toResponseError,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useCustomFieldCache } from './cache'

export function useUpdateCustomField(): UpdateHookResponse<CustomFieldData, CustomFieldData> {
  const cache = useCustomFieldCache()

  const mutation = useTantalimMutation<CustomFieldUpdateInput, CustomFieldUpdateSuccess>({
    url: '/customField/update',
  })

  async function update(unsaved: CustomFieldData): Promise<CustomFieldData> {
    try {
      const { customField } = await mutation.mutateAsync({ customField: unsaved })
      cache.clearList()
      cache.setItem(customField)
      return customField
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
